import React from 'react';

// AccommodationCommittee.jsx
const SpecialSessionData = [
    {"session_title" : "Session 1",
      "track_title" : "Track 1: Next-Generation Communication Technologies",
      "item_title" : "Session Chair",
      "link_pdf" : "Track1.pdf",
      "items" : [
        {list:"Dr Ishu Sharma, Chandigarh Group of Colleges Jhanjeri, Mohali, Punjab, India - 140307, Chandigarh Engineering College, Department of Computer Science and Engineering"},
        {list:"Keshav Kaushik, Center for Cyber Security and Cryptology, Sharda School of Computer Science & Engineering, Sharda University, Greater Noida, India"},
        {list:"Aryan Chaudhary, Chief Scientific Advisor, Bio Tech Sphere Research"},
      ],
    },
    {"session_title" : "Session 2",
      "track_title" : "Track 2: Edge AI and Federated Intelligence for Secure and Real-Time Communication Systems",
      "item_title" : "Session Chair",
      "link_pdf" : "Track2.pdf",
      "items" : [
        {list:"Dr. Shubham Mahajan, Assistant Professor, Amity School of Engineering & Technology, Amity University Haryana"},
        {list:"Prof. (Dr.) Amit Kant Pandit, School of Electronics & Communication Engineering, Shri Mata Vaishno Devi University, Katra, J&K"},
        {list:"Prof. (Dr.) Paras Chawla, Amity School of Engineering & Technology, Amity University Haryana"},
        {list:"Dr. Kamal Upreti, CHRIST (Deemed to be University), Delhi NCR, Ghaziabad, India"}
      ],
    },
    {"session_title" : "Session 3",
      "track_title" : "Track 3: AI-Enabled Advances& Applications",
      "item_title" : "Session Chair",
      "link_pdf" : "Track3.pdf",
      "items" : [
        {list:"Prof. (Dr.) Sugandhi Malhotra, Chandigarh Group of Colleges Jhanjeri, Mohali, Punjab, India - 140307, Chandigarh Engineering College, APEX."}
      ],
    },
    {"session_title" : "Session 4",
      "track_title" : "Track 4: AI and Machine Learning Innovations in Communication Systems",
      "item_title" : "Session Chair",
      "link_pdf" : "Track4.pdf",
      "items" : [
        {list:"Dr Chirag Sharma, Head of Department, Lovely Professional University"},
        {list:"Dr. Vikrant Sharma, Graphic Era Hill University, Dehradun"},
        {list:"Dr. Tanya Nagpal, Lovely Professional University, Jalandhar"}
      ],
    },
    {"session_title" : "Session 5",
      "track_title" : "Track 5: Interdisciplinary Innovations in Emerging Technologies",
      "item_title" : "Session Chair",
      "link_pdf" : "Track5.pdf",
      "items" : [
        {list:"Dr. Pardeep Kumar Jindal, Department of Interdisciplinary Courses in Engineering (DICE), Chitkara University Institute of Engineering and Technology (CUIET), Chitkara University, Punjab"}
      ],
    },
    {"session_title" : "Session 6",
      "track_title" : "Track 6: Federated Learning in Healthcare for Privacy-Preserving AI",
      "item_title" : "Session Chair",
      "link_pdf" : "Track6.pdf",
      "items" : [
        {list:"Dr. Shubham Mahajan, Amity School of Engineering & Technology, Amity University Haryana"},
        {list:"Dr. Davinder Paul Singh, Pandit Deendayal Energy University- PDEU, Gandhinagar, Gujarat"},
        {list:"Prof. (Dr.) Parveen Singla, Amity School of Engineering & Technology, Amity University Haryana"}
      ]     
    },
    {"session_title" : "Session 7",
      "track_title" : "Track 7: Integrating Machine Learning, Deep Learning, IoT, AI, and Data Science for Future Innovations",
      "item_title" : "Session Chair",
      "link_pdf" : "Track7.pdf",
      "items" : [
        {list:"Dr. Puneet Garg, Department of CSE (AI & ML), KIET Group of Institutions, Delhi NCR, Ghaziabad, Uttar Pradesh-201206, India"},
        {list:"Dr. Sonia Setia, Professor, School of Computer Science  Engineering, Galgotias University, Greater Noida, Uttar Pradesh, India"}
      ],
    },
    {"session_title" : "Session 8",
      "track_title" : "Track 8: Frontiers in Data Science: Models, Methods, and Challenges",
      "item_title" : "Session Chair",
      "link_pdf" : "Track8.pdf",
      "items" : [
        {list:"Dr. Rini Saxena, Chandigarh Group of Colleges Jhanjeri, Mohali, Punjab, India - 140307, Chandigarh Engineering College, Department of Computer Science & Engineering"},        
      ],
    },
    {"session_title" : "Session 9",
      "track_title" : "Track 9: Advances in VLSI and Semiconductor Technologies for Next-Gen AI & Communication Systems",
      "item_title" : "Session Chair",
      "link_pdf" : "Track9.pdf",
      "items" : [
        {list:"Dr. Raj Kumar, Chandigarh Group of Colleges Jhanjeri, Mohali, Punjab, India - 140307, Chandigarh Engineering College, Department of Electronics & Communication."},
        {list:"Dr. Ankur Garg, Chandigarh Group of Colleges Jhanjeri, Mohali, Punjab, India - 140307, Chandigarh Engineering College, Department of Electronics & Communication"},
        {list:"Dr. Parveen Kumar, Chandigarh Group of Colleges Jhanjeri, Mohali, Punjab, India - 140307, Chandigarh Engineering College, Department of Electronics & Communication"},
        {list:"Dr. Shashi Bala, Chandigarh Group of Colleges Landran, Mohali, Punjab, India - 140307, Chandigarh Engineering College, Department of Electronics & Communication"},     
      ],
    },
    {"session_title" : "Session 10",
      "track_title" : "Track 10: AI-Driven Communication Systems",
      "item_title" : "Session Chair",
      "link_pdf" : "Track10.pdf",
      "items" : [
        {list:"Dr. Anshu Sharma, Associate Professor, School of Computer Science and Engineering, Lovely Professional University"},        
      ],
    },
    {"session_title" : "Session 11",
      "track_title" : "Track 11: Trends and Innovations in Artificial Intelligence & Smart Computing",
      "item_title" : "Session Chair",
      "link_pdf" : "Track11.pdf",
      "items" : [
        {list:"Dr. Ahthasham Sajid, Department of Computer Science, Fazaia Bilquis College of Education for Women, PAF Nur Khan Base, Air University, Islamabad, Pakistan"},
        {list:"Dr. Noshina Tariq, Assistant Professor, Department of Artificial Intelligence and Data Science, National University of Computer and Emerging Sciences (NUCES), Islamabad, Pakistan"},
        {list:"Dr. Afia Zafar, Assistant Professor, Department of Computer Science, NUTECH University, Islamabad, Pakistan"},   
      ],
    }
    
  ];
const SpecialSessions = () => {
  return (
    <div>
     
      <div className='container mx-auto p-4 pt-15 sm:pt-4 mb-4'>
        {SpecialSessionData.map((member, index) => (
          <>
          <div className="flex flex-wrap w-full relative flex-col flex-auto px-9 mt-4 mb-4 pt-4">
            <h1 className="text-[1.75rem] font-bold text-dark text-4xl uppercase">{member?.session_title}:</h1>
            <p key={index}>{member?.track_title}</p>
          </div>
          <div className="flex flex-wrap w-full relative flex-col flex-auto px-9">
            <p className="text font-bold mb-2">{member?.item_title}:</p>
            <div className="flex w-full text-2l">            
              <ul className="list-disc pl-15 mb-2">
                {member?.items.map((memberLatest, key) => (
                  <li key={key} className="text-lg sm:text-2l">
                    {memberLatest.list}
                  </li>
                ))}
              </ul>            
            </div>
            <div className="text font-bold">
              <span class="font-extrabold">Call for Paper: </span> 
              <a href={`/static/files/${member?.link_pdf}`} target="_blank" rel="noopener noreferrer">View PDF</a>
            </div>
          </div>
          </>
        ))}
        
        
      </div>
    </div>
  );
};

export default SpecialSessions;